import { cloneDeep } from 'lodash';
import { UUID } from 'v2/core/entities/uuid';
import { NormalisedNode } from 'v2/querybuilder/types/querystore';

interface removeQueryFilterNodeParams {
  parentID?: UUID;
  nodes: Record<string, NormalisedNode>;
  node: NormalisedNode;
}

export function removeQueryFilterNode({
  parentID,
  nodes,
  node,
}: removeQueryFilterNodeParams): Record<string, NormalisedNode> {
  if (!parentID) {
    return nodes;
  }

  const updatedNodes = cloneDeep(nodes);
  const parentNode = updatedNodes[parentID];

  if (parentNode.type !== 'group') {
    return updatedNodes;
  }

  delete updatedNodes[node.id];

  const nodeIndex = parentNode.children.indexOf(node.id);
  if (nodeIndex >= 0) {
    parentNode.children.splice(nodeIndex, 1);
  }

  if (!parentNode.children.length) {
    return removeQueryFilterNode({
      parentID: parentNode.parent,
      nodes: updatedNodes,
      node: parentNode,
    });
  }

  if (parentNode.children.length === 1 && parentNode.parent) {
    const childID = parentNode.children[0];
    const child = updatedNodes[childID];
    const grandparent = updatedNodes[parentNode.parent];

    if (grandparent.children) {
      // Link grandparent to child
      const parentIDIndex = grandparent.children?.indexOf(parentID);
      grandparent.children[parentIDIndex] = childID;
      child.parent = grandparent.id;

      // Delete parent node
      delete updatedNodes[parentID];
    }
  }

  return updatedNodes;
}
